@if (client$ | async; as client) {
  <zah-client-fiche-beheer
    [client]="client"
    (cancelClicked)="onCancelClicked(client)"
    (okClicked)="onOkClicked($event)">
  </zah-client-fiche-beheer>
}
